<template>
  <div>
    <div class="form-container ou-donation-form form--minyan">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Ways to give:">
            <DonationFrequency />
          </FormSection>
          <AmountSelectorMinyanYavneh />
          <ErrorLabel field="amount" />
          <TransactionFee />
          <FormSection title="">
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.naming" /> Would you like us to
                contact you regarding naming opportunities?
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  components: {},
  setup(props) {
    const { form } = usePaymentForm();

    return {
      form,
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form.form--minyan {
  background-color: white;
  margin: 20px auto;
  border: none;
  box-shadow: none;
}

::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label
  .label-amount {
  background: #284ee2;
  border-color: #15329d;
}

::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #15329d;
  color: white;
}

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
